import { inject, injectable } from 'tsyringe';
import { BaseViewModel } from '@/shared/viewmodels/BaseViewModel';
import { IAnalyticsGatewayToken, type IAnalyticsGateway } from '@/shared/analytics/AnalyticsGateway';
import type { AnalyticsFilter, RePromptTurn } from '@/shared/analytics/AnalyticsTypes';

/**
 * Loads one person's re-prompt turns — the near-identical prompts they re-submitted
 * within the window — for the Frustration drill. The page clusters them by
 * `promptHash` into "asked N× in M min" groups.
 */
@injectable()
export class RePromptTurnsViewModel extends BaseViewModel {
    turns: RePromptTurn[] = [];
    loading = false;
    errorMessage: string | null = null;

    constructor(@inject(IAnalyticsGatewayToken) private gateway: IAnalyticsGateway) {
        super();
    }

    async load(userId: string, filters: AnalyticsFilter[]): Promise<void> {
        this.turns = [];
        this.loading = true;
        this.errorMessage = null;
        this.notifyChange();
        try {
            this.turns = await this.gateway.rePromptTurns({ userId, filters });
        } catch (err) {
            this.errorMessage = err instanceof Error ? err.message : String(err);
        } finally {
            this.loading = false;
            this.notifyChange();
        }
    }
}
